/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiAgentRemoveAgentDeptDelete$Params {

/**
 * Interface language
 */
  lang?: string;

/**
 * * id sites agent
 */
  orgId?: number;
}

export function apiAgentRemoveAgentDeptDelete(http: HttpClient, rootUrl: string, params?: ApiAgentRemoveAgentDeptDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiAgentRemoveAgentDeptDelete.PATH, 'delete');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('orgId', params.orgId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiAgentRemoveAgentDeptDelete.PATH = '/api/Agent/RemoveAgentDept';
